export default {
  token_expired_title: `Ce lien d'invitation n'est plus valide.`,
  token_expired_message1: 'Veuillez contacter',
  token_expired_message2: 'pour savoir si un nouveau lien est disponible.'
};
